import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { VolumesSection } from './components/VolumesSection';
import { LessonFeaturesSection } from './components/LessonFeaturesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { initMetaPixel } from './utils/pixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-black text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0" data-mp="23t8g8bfz6dbv">
      <main data-id="element-1" data-mp="3ii4qvyobommz">
        <Hero data-id="element-2" data-mp="3mlawr57iwbsx" />
        <TestimonialsStrip data-id="element-3" data-mp="3ml17xky7saot" />
        <PainPoints data-id="element-4" data-mp="3mk83iqmq9x9u" />
        <SolutionReveal data-id="element-5" data-mp="3mjg9hk8s47lo" />
        <VolumesSection data-id="element-6" data-mp="3rc9hqi3ghy2i" />
        <LessonFeaturesSection data-id="element-7" data-mp="3rbzo8kj7d8s2" />
        <BonusSection data-id="element-8" data-mp="3rcsuzli5vya7" />
        <PricingSection data-id="element-9" data-mp="3relvej26lm9r" />
        <ExtendedTestimonials data-id="element-10" data-mp="6hqffdy0fe4" />
        <Guarantee data-id="element-11" data-mp="4n5w26l2pak" />
        <FAQ data-id="element-12" data-mp="56l3b4umzkw" />
        <FinalCTA data-id="element-13" data-mp="7suzhf7pr6a" />
      </main>
      <Footer data-id="element-14" data-mp="2zllduyaeeel5" />
      <PurchaseNotifications data-id="element-15" data-mp="2zm4ywnvchj3e" />
    </div>;
}